import { Component, inject, signal } from '@angular/core';
import { SessionStoreService } from '../../core/services/session-store.service';

@Component({
  selector: 'bpw-loader-refresh',
  standalone: true,
  templateUrl: './loader-refresh.component.html',
  styleUrls: ['./loader-refresh.component.scss'],
})
export class LoaderRefreshComponent {
  private readonly _sessionStoreService = inject(SessionStoreService);

  showInitialText = signal(false);

  constructor() {
    if (this._sessionStoreService.keyExists('initialDataLoad')) {
      this._sessionStoreService.remove('initialDataLoad');
      this.showInitialText.set(true);
    }
  }
}
